/** Router state the clone flow sets so the editor opens on Properties with the Name focused. */
export const RULEBOOK_EDITOR_FOCUS_NAME_STATE = { focusName: true } as const;

export default function isRulebookEditorFocusNameState(state: unknown): boolean {
  if (typeof state !== "object" || state === null) {
    return false;
  }
  return (state as { focusName?: unknown }).focusName === true;
}
